import { Injectable } from "@angular/core";
import { AngularFireDatabase, AngularFireList } from "angularfire2/database";
import { Observable } from "rxjs/Observable";

@Injectable()
export class RacesService {
  drivers: AngularFireList<any>;
  raceImages: AngularFireList<any>;
  constructor(private afd: AngularFireDatabase) {}

  storeDriver(duomenys: any, race: string) {
    this.drivers = this.afd.list("races/" + race + "/drivers");
    this.drivers.push(duomenys);
  }

  getDrivers(race: string) {
    this.drivers = this.afd.list("races/" + race + "/drivers");
    return this.drivers.snapshotChanges(["child_added"]);
  }
  getRaceMap(race: string) {
    let raceMap = this.afd.object("races/" + race + "/image");
    return raceMap;
  }
  getCircuitDetails(race: string) {
    let circuitDetails = this.afd.object("details/" + race);
    return circuitDetails;
  }
  getBtnStatus(race: string) {
    let btnStatus = this.afd.object("races/" + race + "/btn");
    return btnStatus;
  }
  getHomePage() {
    let homePage = this.afd.object("races/homePage");
    return homePage;
  }
  getImages(race: string) {
    let raceImages = this.afd.object("gallery/" + race);
    return raceImages;
  }
  getActiveClass() {
    let btnStatus = this.afd.object("gallery/2022/statuses");
    return btnStatus;
  }

  getRaceDate(year: string) {
    return this.afd.object("calendar/" + year);
  }
  getOneRaceDate(year: string, id: string) {
    return this.afd.object("calendar/" + year + "/" + id);
  }
}



// WEBPACK FOOTER //
// ./src/app/calendar/races/raceServices/races.service.ts